import { executeRequest, Request, Response } from '@jfs/network'
import { Config } from 'react-native-config'
import { APIEndPoints } from './APIEndpoints'
import { sitConfig } from './config'

const responseParser = (res: Response) => {
  if (res?.data?.responseStatus?.code === '000') {
    return {
      ...res?.data?.responseObj.agent?.agentStatus,
    }
  } else {
    const errorMsg = {
      errorCode: res?.data?.error?.code,
      errorMessage: res?.data?.error?.message,
    }
    throw errorMsg
  }
}

const returnBody = (merchantId) => {
  return {
    domain: {
      id: 'PayMyBill',
      name: 'PayMyBill',
      orderType: 'BUY',
      description: 'This is for the buy case.',
    },
    initiatingEntity: {
      entityId: Config.REACT_APP_CHANNEL_ID,
      channelId: Config.REACT_APP_CHANNEL_ID,
    },
    agent: {
      merchantId: merchantId,
    },
  }
}

export const searchAgent = (tokens, userAccessToken, merchantId) => {
  const config = sitConfig(tokens)
  //config.baseUrl = Config.REACT_APP_JFS_BASE_URL
  const request: Request<{}> = {
    apiPath: APIEndPoints.searchAgent,
    method: 'POST',
    body: returnBody(merchantId),
    config: config,
    headers: {
      'Content-Type': 'application/json',
      Authorization: userAccessToken,
    },
  }

  return executeRequest(request)
    .then(responseParser)
    .catch((error) => {
      throw error
    })
}
